import { render, staticRenderFns } from "./ResourceDownloadButton.vue?vue&type=template&id=68fa8983&scoped=true"
import script from "./ResourceDownloadButton.vue?vue&type=script&lang=js"
export * from "./ResourceDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./ResourceDownloadButton.vue?vue&type=style&index=0&id=68fa8983&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa8983",
  null
  
)

export default component.exports